import { render, staticRenderFns } from "./selecttemplate.vue?vue&type=template&id=ccfa49cc&"
import script from "./selecttemplate.js?vue&type=script&lang=js&"
export * from "./selecttemplate.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\Bont\\Frontend\\BontScheduler.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ccfa49cc')) {
      api.createRecord('ccfa49cc', component.options)
    } else {
      api.reload('ccfa49cc', component.options)
    }
    module.hot.accept("./selecttemplate.vue?vue&type=template&id=ccfa49cc&", function () {
      api.rerender('ccfa49cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/common/inputs/selecttemplate.vue"
export default component.exports